// Vendors
import { useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Constants
import { GET_STATE_POLLING_PROPS } from '../constants/get-state.constants';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Hooks
import { useAppGetStateHook } from 'hooks/get-state.hook';
// Handlers
import { GetStateHandlers } from 'containers/get-state/handlers/get-state.handlers';

const useGetStateHook = (): void => {
  const { showBoundary: setError } = useErrorBoundary();

  const { callbackUrl, loanId, setCurrentState } = useAppContextConsumerHook();

  const {
      handleManageOnSuccessGetOnboardingStateEvent: onSuccess,
      handleManageOnErrorGetOnboardingStateEvent: onError,
    } = GetStateHandlers({
      callbackUrl,
      loanId,
      setCurrentState,
      setError,
    }),
    { handleGetOnboardingStateEvent } = useAppGetStateHook({
      ...GET_STATE_POLLING_PROPS,
      onError,
      onSuccess,
    });

  useEffect(() => {
    handleGetOnboardingStateEvent();
  }, []);
};

export { useGetStateHook };
